export enum RaceStartType {
  RACE = 1,
  MAN = 2,
  WOMAN = 3,
  BLOCK = 4,
  CHRONOMETER_RACE = 5
}
